<template>
  <header :class="{ black: isVacancy }">
    <div class="container">
      <logo-container />
      <nav class="nav-header">
        <ul>
          <li><a href="/df/">Головна</a></li>
          <li><a href="/df/#about">Про проєкт</a></li>
          <li><a href="/df/#recruit-process">Процес рекрутингу</a></li>
          <li><a href="/df/#vacancy">Вакансії</a></li>
          <li><a href="/df/#form">Анкета</a></li>
        </ul>
      </nav>
      <a class="phone" href="tel:+380800301314">+380 800 301 314</a>
      <div class="mob">
        <img
          @click="openMobMenu"
          src="@/assets/images/icons/burger.svg"
          alt="icon"
        />
        <div class="mob__menu" v-if="isOpenMob">
          <img
            @click="openMobMenu"
            class="mob__close"
            src="@/assets/images/icons/plus-white.png"
            alt="icon"
          />
          <nav class="mob__nav-header">
            <ul>
              <li><a href="/df/">Головна</a></li>
              <li><a href="/df/#about">Про проєкт</a></li>
              <li><a href="/df/#recruit-process">Процес рекрутингу</a></li>
              <li><a href="/df/#vacancy">Вакансії</a></li>
              <li><a href="/df/#form">Анкета</a></li>
            </ul>
          </nav>
          <a class="phone mob__phone" href="tel:+380800301314">
            +380 800 301 314
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import LogoContainer from "@/components/page/modules/LogoContainer.vue";

export default {
  name: "custom-header",
  components: { LogoContainer },
  props: {
    isVacancy: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpenMob: false,
    };
  },
  methods: {
    openMobMenu() {
      this.isOpenMob = !this.isOpenMob;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  background: transparent;
  display: block;
  position: absolute;
  top: 0;
  height: 120px;
  width: 100vw;
  z-index: 1;

  &.black {
    background: #1c1c1c;
  }

  @media (max-width: 1100px) {
    padding: 26px 0 0 !important;
    box-sizing: border-box;
    position: relative;
    background: black;
  }
}

.container {
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  height: 120px;
  @media (max-width: 767px) {
    height: 80px;
  }
}

.nav-header {
  @media (max-width: 1360px) {
    display: none;
  }
  ul {
    display: flex;
    align-items: center;
    gap: 55px;

    li {
      font-weight: 400;
      font-size: 18px;
      line-height: 100%;
      list-style-type: none;

      a {
        color: white;
        text-decoration: none;
      }
    }
  }
}

.phone {
  font-family: UAF Sans SB, serif;
  font-weight: 500;
  font-size: 24px;
  line-height: 100%;
  color: white;
  text-decoration: none;

  @media (max-width: 1360px) {
    display: none;
  }
}

.mob {
  display: none;
  @media (max-width: 767px) {
    .mob__menu[data-v-552fc5cd] {
      width: 235px;
      height: 100vh;
      background: #0a0a0a;
      position: absolute;
      top: -46px;
      right: -10px;
      padding: 72px 20px 0;
      box-sizing: border-box;
    }
  }
  @media (max-width: 1360px) {
    display: block;
    position: relative;
    img {
      width: 40px;
      cursor: pointer;
    }

    &__menu {
      width: 235px;
      height: 100vh;
      background: #0a0a0a;
      position: absolute;
      top: -40px;
      right: -10px;
      padding: 72px 20px 0;
      box-sizing: border-box;
    }

    &__nav-header {
      ul {
        display: flex;
        flex-direction: column;
        gap: 20px;

        li {
          list-style-type: none;
          a {
            font-family: "UAF Sans HR", serif;
            font-weight: 400;
            font-size: 16px;
            line-height: 100%;
            color: #fff;
            text-decoration: none;
          }
        }
      }
    }

    &__phone {
      margin-top: 100px;
      display: block;
      font-family: "UAF Sans HR", serif;
      font-weight: 500;
      font-size: 17px;
      line-height: 100%;
    }

    &__close {
      transform: rotate(45deg);
      width: 24px !important;
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }
}
</style>
